// @ts-nocheck

import { useDispatch, useSelector } from 'react-redux'
import { ReduxState } from '../../../redux/rootReducer'
import * as S from './Home.styles'

import { CategoryCard } from './Components/CategoryCard/CategoryCard'
import {
  BottomNavigation,
  BottomNavigationSpacer
} from '../../../components/bottomNavigation/BottomNavigation'
import { Hidden } from 'applaus-ui-kit'
import { AppBar } from '../../../components/appBar/AppBar'

import { CashBackEvents } from './Components/CashBackEvents/CashBackEvents'
import { Courses } from './Components/CoursesSection/CoursesSections'
import { useEffect } from 'react'
import { listEventsRequestAction } from '../../../redux/Content/actions'
import { Footer } from '../../../components/footer/Footer'
import { motion } from 'framer-motion'
import { Loading } from '../../../components/loading/Loading'
import { useAutoLocation } from '../../../hooks/useAutoLocation'

export const Home = () => {
  const { ContentsReducer, LoadingReducer } = useSelector(
    (state: ReduxState) => state
  )

  const { categories } = ContentsReducer
  const dispatch = useDispatch()
  const location = useAutoLocation()

  useEffect(() => {
    dispatch(
      listEventsRequestAction(
        location?.state || location?.city ? location : undefined
      )
    )
  }, [location?.state, location?.city, dispatch])

  return (
    <>
      {!ContentsReducer.isLoading ? (
        <motion.div
          initial={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          animate={{ opacity: 1 }}>
          <S.Container>
            <Hidden mobile>
              <AppBar />
            </Hidden>
            <>
              <S.CategoryWrapper>
                {categories.map((category, index) => (
                  <CategoryCard
                    key={category.id}
                    index={index + 1}
                    {...category}
                  />
                ))}
              </S.CategoryWrapper>
              <CashBackEvents />
              <Courses />
            </>
            <BottomNavigationSpacer />
            <BottomNavigation active="home" />
            <Footer />
          </S.Container>
        </motion.div>
      ) : (
        <Loading
          isLoading={ContentsReducer.isLoading}
          blur={false}
          disableBackground={LoadingReducer.isLoading}
        />
      )}
    </>
  )
}
